import * as React from 'react'
import { ReactElement, useContext, useMemo } from 'react'
import Loading from '../Loading'
import { Card, mergeClasses, Text } from '@fluentui/react-components'
import MessageContext from '../../context/MessageContext'
import { formatFullDateTime } from '../../helpers/dateHelper'
import { useTranslation } from 'react-i18next'
import PersonAvatar from '../PersonAvatar'
import { usePageStyles } from './FileMessage'

function Body(): ReactElement {
    const pageStyles = usePageStyles()
    const { t: translate } = useTranslation()

    const { outlookMessage, message } = useContext(MessageContext)
    const outlookMessageRead = useMemo(() => outlookMessage as Office.MessageRead, [outlookMessage])

    return (
        <div>
            <Text size={500}>{outlookMessageRead?.subject?.toString()}</Text>
            <div className={mergeClasses(pageStyles.container)}>
                <PersonAvatar name={outlookMessageRead?.from?.displayName} color="colorful" size={48} />
                <div className={mergeClasses(pageStyles.description)}>
                    <Text>{outlookMessageRead?.from?.displayName || outlookMessageRead?.from?.emailAddress}</Text>
                    <Text>
                        {translate('email.filing.to')}
                        :&nbsp;
                        {outlookMessageRead?.to?.map?.(recipient => recipient?.displayName || recipient?.emailAddress)?.join(', ')}
                    </Text>
                </div>
                <Text>{formatFullDateTime(message.data?.sentDateTime || outlookMessageRead?.dateTimeCreated)}</Text>
            </div>
        </div>
    )
}

export default function FileMessageHeader(): ReactElement {
    const { t: translate } = useTranslation()

    const { outlookMessage, message } = useContext(MessageContext)
    const outlookMessageRead = useMemo(() => outlookMessage as Office.MessageRead, [outlookMessage])

    if (message.loading) {
        return <Loading label={translate('base.loading')} />
    }

    return (
        <Card>
            {!outlookMessageRead && <Text block>{translate('email.filing.dialog.subject_zero')}</Text>}
            {outlookMessageRead && <Body />}
        </Card>
    )
}
